<!-- BSG-compliant hours modal with keyboard accessibility -->
<ion-content role="dialog" aria-labelledby="venue-hours-title">
	<div class="hours-modal-wrapper bsg-hours-modal">
		<!-- Close button with keyboard accessibility -->
		<button class="close-btn bsg-close-button" (click)="dismiss()" aria-label="Close">
			<ion-icon size="large" src="../../../assets/dean_and_david/cross_black.svg" aria-hidden="true"></ion-icon>
		</button>

		<!-- Logo and venue information -->
		<ion-img class="logo" src="../../../assets/dean_and_david/logo-big.png" alt="Dean and David logo"></ion-img>

		<!-- Venue details -->
		<h1 id="venue-hours-title" class="venue-name bsg-visually-hidden">
			{{ 'working_hours_modal.header.' + environment.customerGroup | translate }} -
			{{ venue.name }}
		</h1>

		<p class="address">{{ venue.street }} {{ venue.number }}, {{ venue.postalCode }}</p>

		<p class="tel">
			{{ 'working_hours_modal.tel' | translate }}:
			<a *ngIf="venue.phoneNumber" href="tel:{{ venue.phoneNumber }}" tabindex="0">{{ venue.phoneNumber }}</a>
			<span *ngIf="!venue.phoneNumber">-</span>
		</p>

		<div class="separators">
			<div class="line" aria-hidden="true"></div>
		</div>

		<!-- Working hours section -->
		<div class="open-time">
			<!-- Opening hours table -->
			<section class="info-row first ion-align-items-start ion-justify-content-between">
				<h2 class="subtitle time-title">{{ 'working_hours_modal.working_hours' | translate }}:</h2>

				<div class="info hours-table" role="table" [attr.aria-label]="'working_hours_modal.working_hours' | translate">
					<!-- Days of the week with hours -->
					<div *ngFor="let weekDay of days; let i = index" role="row" class="hours-row">
						<div class="day-column ion-no-padding" role="cell">
							<p class="info">{{ weekDay }}</p>
						</div>
						<div class="hours-column ion-no-padding" role="cell">
							<p>
								<span *ngFor="let dayText of dayText(venue.openingHours, i)" class="info">{{ dayText }}</span>
							</p>
						</div>
					</div>
				</div>
			</section>

			<!-- Delivery hours table (if available) -->
			<section *ngIf="venue.deliveryHours.length > 0" class="info-row first ion-justify-content-between">
				<h2 class="subtitle time-title">{{ 'working_hours_modal.delivery_hours' | translate }}:</h2>

				<div class="info hours-table" role="table" [attr.aria-label]="'working_hours_modal.delivery_hours' | translate">
					<!-- Days of the week with delivery hours -->
					<div *ngFor="let weekDay of days; let i = index" role="row" class="hours-row">
						<div class="day-column ion-no-padding" role="cell">
							<p class="info">{{ weekDay }}</p>
						</div>
						<div class="hours-column ion-no-padding" role="cell">
							<p>
								<span *ngFor="let dayText of dayText(venue.deliveryHours, i)" class="info">{{ dayText }}</span>
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>

	<!-- Footer links -->
	<div class="links_block bsg-links-block">
		<button class="link bsg-link-button" (click)="toImprint()" tabindex="0">
			{{ 'menu_popover.imprint' | translate }}
		</button>

		<button class="link bsg-link-button" (click)="toAGB()" tabindex="0">
			{{ 'menu_popover.terms' | translate }}
		</button>

		<button class="link bsg-link-button" (click)="toPrivacy()" tabindex="0">
			{{ 'menu_popover.privacy' | translate }}
		</button>
	</div>
</ion-content>
